import { render, staticRenderFns } from "./CustomerITRQ.vue?vue&type=template&id=c7852696&scoped=true&"
import script from "./CustomerITRQ.vue?vue&type=script&lang=ts&"
export * from "./CustomerITRQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7852696",
  null
  
)

export default component.exports